<template>
    <div>
        <div class="role_loading" v-if="role_loading">
            <van-loading type="spinner" size="3rem" />
        </div>
        
        <div v-if="cPack == 'pack'">
            <div class="goods" v-if="role_id">
                <div v-if="backpack.length > 0 && cPack == 'pack' && show1" class="goods-list">
                    <goods-item v-for="(row, i) in backpack" :row="row" :key="i" />
                </div>
                <div class="text" v-else-if="show1 && backpack.length == 0 && cPack == 'pack'">
                    <p>{{ text1 }}</p>
                    <van-button class="refresh" icon="replay" color="var(--theme)" round size="small"
                        @click="refresh(1)" v-if="text1 != '(您当前没有可交易物品,先去市场逛逛吧)'">刷新</van-button>
                </div>
                <!-- <div v-if="onsell.length > 0 && cPack == 'ing' && show2" class="goods-list">
                    <sellgoods-item v-for="(row, i) in onsell" :row="row" :key="i" />
                </div>
                <div class="text" v-else-if="show2 && onsell.length == 0 && cPack == 'ing'">
                    <p>{{ text2 }}</p>
                    <van-button class="refresh" icon="replay" color="var(--theme)" round size="small" @click="refresh(2)" v-if="text2 != '(您当前没有正在出售的物品,先去市场逛逛吧)'">刷新</van-button>
                </div> -->
            </div>
            <div class="role_area" v-if="!role_id && cPack == 'pack'">
                <div v-if="prop_trade == 1 && role_trade == 0">
                    <div class="role_list" v-if="roleList.length > 0">
                        <div class="role_box" v-for="(item,i) in roleList" :key="i">
                            <div class="account_role">
                                <div class="account">
                                    <van-image class="user" :src="require('../../assets/version_1.3.0/sell/user.png')" />
                                    账号：{{ item.account  }}
                                </div>
                            </div>
                            <div :class="['roles',{'active': role_id == row.role_id}]" v-for="(row,k) in item.roleList"
                                :key="k" @click="chooseRole(row.role_id,row.role_name,row.server_id,row.server_name,item.account_id)">
                                {{ row.server_name }}
                                {{ row.role_name }}
                            </div>
                        </div>
                        <el-button class="bind_more" type="primary" @click="bindmorerole">绑定更多账号</el-button>
                    </div>
                    <div v-else>
                        <van-image class="no_role_img" :src="require('../../assets/bx/acc/none.png')"></van-image>
                        <van-button class="no_role" color="var(--theme)" round size="small" @click="gotoBind">{{ app_id?'暂无角色，前往绑定': '请先选择游戏' }}
                        </van-button>
                    </div>
                </div>
                <div v-else>
                    <div class="role_list" v-if="roleList.length > 0">
                        <div class="role_box" v-for="(item,i) in roleList" :key="i">
                            <div class="account_role">
                                <div class="account">
                                    <van-image class="user" :src="require('../../assets/version_1.3.0/sell/user.png')" />
                                    {{ item.game_account }}
                                </div>
                            </div>
                            <div v-if="cPack == 'pack'">
                                <div class="child" v-if="item.child_list">
                                    <ul>
                                        <li class="child_item" v-for="(its,k) in item.child_list" :key="k">
                                            <div>{{ its.nickname }}</div>
                                            <div class="sell_btns">
                                                <el-button class="sell prop" @click="sell(1,item.id,item.game_account,its.jh_user_id)"
                                                    v-if="prop_trade == 1">卖道具</el-button>
                                                <el-button class="sell role" @click="sell(2,item.id,item.game_account,its.jh_user_id)"
                                                    v-if="role_trade == 1">卖角色</el-button>
                                            </div>
                                        </li>
                                    </ul>
                                </div>
                                <div class="sell_btns" v-else>
                                    <el-button class="sell prop" @click="sell(1,item.id,item.game_account)"
                                    v-if="prop_trade == 1">卖道具</el-button>
                                    <el-button class="sell role" @click="sell(2,item.id,item.game_account)"
                                    v-if="role_trade == 1">卖角色</el-button>
                                </div>
                            </div>

                        </div>
                        <el-button class="bind_more" type="primary" @click="bindmorerole">绑定更多账号</el-button>
                    </div>
                    <div v-else>
                        <van-image class="no_role_img" :src="require('../../assets/bx/acc/none.png')"></van-image>
                        <van-button class="no_role" color="var(--theme)" round size="small" @click="gotoBind">{{ app_id?'暂无角色，前往绑定': '请先选择游戏' }}
                        </van-button>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="cPack == 'ing'">
            <div v-if="app_id">
                <order-scroll url="goods-role/manage" :params="{status: 1,app_id:app_id}" ref="manage" @on-fetch="fetch">
                    <template slot-scope="scope">
                        <div v-for="(item,i) in scope.data" :key="i">
                            <manage-item :info="item" :status_maps="status_maps"/>
                        </div>
                    </template>
                </order-scroll>
            </div>
            <div v-else style="padding-top: .5rem;">
                <van-image class="no_role_img" :src="require('../../assets/bx/acc/none.png')"></van-image>
                    <van-button class="no_role" color="var(--theme)" round size="small" @click="chooseGame">请先选择游戏
                </van-button>
            </div>
        </div>
    </div>
</template>
<script>
    import ManageItem from '../user/order/ManageItem.vue'
    import {
        debounce
    } from 'riku-verycloud'
    export default {
        data() {
            return {
                showPage: false,
                show1: false,
                show2: false,
                backpack: [],
                onsell: [],
                roleList: [],
                text1: '(您当前没有可交易物品,先去市场逛逛吧)',
                text2: '(您当前没有正在出售的物品,先去市场逛逛吧)',
                role_loading: false,
                status_maps: {}
            };
        },
        components: {
            ManageItem
        },
        computed: {
            app_id() {
                return this.$store.state.gameId
            },
            server_id() {
                return this.$store.state.server_id
            },
            server_name() {
                return this.$store.state.server_name
            },
            role_id() {
                return this.$store.state.role_id
            },
            role_name() {
                return this.$store.state.role_name
            },
            cPack() {
                return this.$store.state.cPack
            },
            roleId_cPack() {
                const {
                    role_id,
                    cPack
                } = this
                return {
                    role_id,
                    cPack
                }
            },
            gameIcon() {
                return this.$store.state.gameIcon;
            },
            prop_trade() {
                return this.$store.state.prop_trade
            },
            role_trade() {
                return this.$store.state.role_trade
            },
            ac_id() {
                return this.$store.state.ac_id
            },
        },
        mounted() {
            setTimeout(() => {
                this.showPage = true
            }, 1000)
        },
        methods: {
            fetch(e) {
                this.status_maps = e.status_maps
            },
            getUserRoleList(app_id) {
                this.showPage = false
                this.$Ajax('user-info/accounts', {
                    app_id
                }).then(rs => {
                    if (rs.code == 200) {
                        this.roleList = rs.data
                    } else {
                        this.roleList = []
                        this.$toast(rs.msg)
                    }
                }).finally(() => {
                    setTimeout(() => {
                        this.showPage = true
                    }, 1000)
                })
            },
            getUserRoleList2(app_id) {
                this.showPage = false
                this.$Ajax('user-info/user-role-list', {
                    app_id
                }).then(rs => {
                    if (rs.code == 200) {
                        this.roleList = rs.data          
                    } else {
                        this.roleList = []
                        this.$toast(rs.msg)
                    }
                }).finally(() => {
                    setTimeout(() => {
                        this.showPage = true
                    }, 1000)
                })
            },
            //我的背包
            getbackpack: debounce(function () {
                this.$Ajax('goods/backpack', {
                    app_id: this.app_id,
                    server_id: this.server_id,
                    server_name: this.server_name,
                    role_id: this.role_id,
                    role_name: this.role_name,
                    account_id: this.ac_id
                }, 'get').then(rs => {
                    this.show1 = true
                    if (rs.code == 200) {
                        this.backpack = rs.data
                    } else {
                        this.backpack = []
                        this.text1 = rs.msg
                    }
                }).finally(() => {
                    setTimeout(() => {
                        this.showPage = true
                    }, 1000)
                })
            }),
            //正在出售
            getSelling: debounce(function () {
                this.$Ajax('goods/on-sale', {
                    app_id: this.app_id,
                    server_id: this.server_id,
                    role_id: this.role_id
                }, 'get').then(rs => {
                    this.show2 = true
                    if (rs.code == 200) {
                        this.onsell = rs.data
                    } else {
                        this.onsell = []
                        this.text2 = rs.msg
                    }
                }).finally(() => {
                    setTimeout(() => {
                        this.showPage = true
                    }, 1000)
                })
            }),
            gotoBind() {
                if(this.app_id) {
                    this.$router.push({
                        name: 'user.bind'
                    })
                }else {
                    this.$filterPop({
                        type: 'game'
                    })
                }
            },
            chooseGame() {
                this.$filterPop({
                    type: 'game'
                })
            },
            chooseRole(role_id, role_name, server_id, server_name, account_id) {
                this.showPage = false
                this.$store.commit('setBindrole', {
                    role_id,
                    role_name,
                })
                this.$store.commit('bindServer', {
                    server_id,
                    server_name
                })
                if(account_id) {
                    this.$store.commit('bindAcid', account_id)
                }
            },
            refresh(i) {
                this.showPage = false
                if (i == 1) {
                    this.getbackpack()
                } else {
                    this.getSelling()
                }
            },
            // 选择卖道具or角色
            sell(index, account_id, account,child_user_id) {
                var that = this
                this.$filterPop({
                    type: 'roleserver',
                    direction: 'up',
                    onSuccess: (data) => {
                        this.role_loading = true
                        this.$Ajax('goods-role/cp-rolelist', {
                            app_id: that.app_id,
                            account_id,
                            server_id: data.server_id,
                            child_user_id
                        },'post',{
                            timeout: 35000  // 设置35秒超时
                        }).then(rs => {
                            if (rs.code == 200) {
                                that.role_loading = false
                                if (rs.data.length > 0) {
                                    this.$RModal.accounts({
                                        noheader: true,
                                        selection: {
                                            app_id: that.app_id,
                                            account_id,
                                            icon: that.gameIcon,
                                            roles: rs.data,
                                            index, //1卖道具  2卖角色  0选角色
                                            account,
                                            child_user_id
                                        },
                                        onSuccess: (info) => {
                                            that.chooseRole(info.role_id, info
                                                .role_name, info.server_id, info
                                                .server_name)
                                        }
                                    })
                                } else {
                                    // 没查到角色 弹框
                                    this.$RModal.norole({
                                        noheader: true
                                    })
                                }
                            } else if (rs.code == 406) {
                                that.role_loading = false
                                // 没查到角色 弹框
                                this.$RModal.norole({
                                    noheader: true,
                                    selection: {
                                        message: rs.msg
                                    }
                                })
                            }else {
                                that.role_loading = false
                            }
                        })
                    }
                })
            },
            bindmorerole() {
                this.$router.push({
                    name: 'user.bindrole'
                })
            }
        },
        watch: {
            app_id: {
                immediate: true,
                handler(e) {
                    if (e) {
                        if (this.prop_trade == 1 && this.role_trade == 0) {
                            if(this.cPack == 'pack') {
                                this.getUserRoleList2(this.app_id)
                            }
                        } else {
                            if(this.cPack == 'pack') {
                                this.getUserRoleList(this.app_id)
                            }
                        }
                    }
                }
            },
            roleId_cPack: {
                immediate: true,
                handler(e) {
                    if (e.cPack == 'pack') {
                        if (e.role_id) {
                            this.getbackpack()
                        }

                    } else {
                        // if(e.role_id) {
                        //     this.getSelling()
                        // }
                    }
                }
            }
        }
    };
</script>
<style lang="less" scoped>
    /deep/.el-loading-mask {
        background-color: transparent;
    }

    .goods {
        min-height: calc(var(--vh, 1vh)*100 - 35rem);

        .goods-list {
            display: flex;
            flex-wrap: wrap;
        }

        .text {
            padding-top: 10rem;
            text-align: center;
            color: rgb(107, 107, 107);
        }
    }

    .no_role_img {
        display: block;
        margin: 5.6rem auto 0;
        width: 20.6rem;
        height: 13.1rem;
    }

    .no_role,
    .loading {
        margin: 2.7rem auto 0;
        display: block;
        padding: 1.2rem;
    }

    .no_role {
        width: 22rem;
        height: 3.6rem;
        font-size: 1.6rem;
    }

    .loading_page {
        display: flex;
        justify-content: center;
    }

    .role_area {
        padding: 0.5rem 0.5rem;
    }

    .role_box {
        padding: 0;
        background-color: #FFE4D8;
        margin-bottom: 1.6rem;
        border-radius: 1rem;
        // height: 7.9rem;
        overflow: hidden;

        .account_role {
            display: flex;
            justify-content: space-between;
            align-items: center;
            border-radius: 1rem;
            background: url(../../assets/version_1.3.0/sell/money.png) no-repeat 100% 0 / 5.8rem 6.1rem;
            color: #000;
            font-size: 1.4rem;
            padding: 0.8rem 1rem;

            .account {
                font-size: 1.5rem;
                display: flex;
                align-items: center;

                .user {
                    width: 1.8rem;
                    height: 1.8rem;
                    margin-right: 0.4rem;
                }
            }

            .role {
                height: 2.4rem;
                line-height: 2.4rem;
                text-align: center;
                border-radius: 10rem;
                color: #fff;
                font-size: 1.2rem;
                display: flex;
                align-items: center;

                .total {
                    background-color: var(--theme);
                    width: 10rem;
                    height: 100%;
                    display: inline-block;
                    border-radius: 100rem;
                    font-size: 1.2rem;
                }

                .el-button {
                    padding: 0;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    height: 100%;
                    width: 8rem;
                    font-size: 1.2rem;
                    margin-left: 1rem;
                }
            }

            .close {
                font-size: 1.8rem;
                cursor: pointer;
            }
        }

        .account_list {
            max-height: calc(var(--vh, 1vh)*100 - 36rem);
            padding-right: 1.2rem;
            overflow-y: auto;

            .account_item {
                padding: 0.4rem 1rem;
                margin-bottom: 0.6rem;
                background-color: #f2f2f2;
                border-radius: 10rem;
                text-align: center;
            }
        }

        .sell_btns {
            display: flex;
            justify-content: center;
            align-items: center;
            padding: 0.9rem 1rem;
            border-radius: 1rem;
            background-color: #fff;
            .sell {
                flex: 1;
                //width: 16rem;
                height: 3rem;
                line-height: 3rem;
                text-align: center;
                padding: 0;
                font-size: 1.4rem;
                border: none;
                color: #fff;
                margin-right: 1.5rem;
                border-radius: 0.5rem;
                &:nth-last-child(1) {
                    margin: 0;
                }
                &.prop {
                    background: url(../../assets/version_1.3.0/sell/props.png) no-repeat 100% 0 / 3.3rem 3rem;
                    background-color: #FF7056;
                }
                &.role {
                    background: url(../../assets/version_1.3.0/sell/role.png) no-repeat 100% 0 / 3.5rem 3rem;
                    background-color: #FF854B;
                }
            }
        }

        .roles {
            padding: 1.2rem 2rem;
            background-color: #fff;
            font-size: 1.3rem;
            margin: .6rem 1rem;
            border-radius: .8rem;
            &.active {
                background-color: var(--theme);
                color: #fff;
            }
        }
    }

    .refresh {
        margin: 1rem 0;
        padding: 0 1rem;
    }

    .bind_more {
        margin: 2rem auto;
        padding: 0;
        width: 12rem;
        height: 3.6rem;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 1.2rem;
    }
    .child {
        background-color: #fff;
        padding: 1.2rem 1rem;
        .child_item {
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: 0 .4rem 0 1rem;
            border: 1px solid rgba(246, 111, 48, 0.3);
            border-radius: .7rem;
            margin-bottom: .9rem;
            &:nth-last-child(1) {
                margin-bottom: 0;
            }
            .sell_btns {
                padding: .4rem .3rem !important;
                .sell {
                    margin-right: .6rem !important;
                    width: 7rem;
                    /deep/span {
                        font-size: 1.2rem;
                        transform: scale(0.9);
                        display: block;
                        text-align: left;
                        padding-left: 1rem;
                    }
                    &.prop {
                        background: url(../../assets/version_1.3.0/sell/props.png) no-repeat 100% .2rem / 2.7rem 2.4rem !important;
                        background-color: #FF7056 !important;
                    }
                    &.role {
                        background: url(../../assets/version_1.3.0/sell/role.png) no-repeat 100% .2rem / 2.7rem 2.4rem !important;
                        margin: 0 !important;
                        background-color: #FF854B !important;
                    }
                }
            }
        }
    }
</style>